import React from "react";
import { Plus, Share2, Download, FileText } from "lucide-react";

const CalendarHeader = ({
  t,
  styles,
  screenSize,
  language,
  onNewEvent,
  onDownloadImage,
  onDownloadPdf,
  onShare,
  canAddEvent = true,
  canExportCalendar = true,
  canShareCalendar = true,
}) => {
  return (
    <div style={styles.headerSection}>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
          background: "linear-gradient(90deg, #2e7cba, #2e7cba, #2e7cba)",
        }}
      />
      <div>
        <div style={styles.headerLeft}>
          <div style={styles.headerText}>
            <h1 style={styles.headerTitle}>{t.calendar}</h1>
            <div
              style={{
                ...styles.headerActions,
                marginLeft: language === "ar" ? 0 : "auto",
                marginRight: language === "ar" ? "auto" : 0,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {canAddEvent && (
                <button
                  style={styles.actionButton("success", "medium")}
                  onClick={onNewEvent}
                >
                  <Plus size={18} />
                  {screenSize.isMobile ? t.new : t.newEvent}
                </button>
              )}

              {canExportCalendar && (
                <>
                  <button
                    style={{
                      ...styles.actionButton("default", "medium"),
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={onDownloadImage}
                    title={language === "ar" ? "تنزيل كصورة" : "Download Image"}
                  >
                    <Download size={16} />
                    {screenSize.isMobile
                      ? language === "ar"
                        ? "صورة"
                        : "Img"
                      : language === "ar"
                      ? "تنزيل صورة"
                      : "Download Image"}
                  </button>

                  <button
                    style={{
                      ...styles.actionButton("default", "medium"),
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={onDownloadPdf}
                    title={language === "ar" ? "تنزيل كـ PDF" : "Download PDF"}
                  >
                    <FileText size={16} />
                    {screenSize.isMobile
                      ? "PDF"
                      : language === "ar"
                      ? "تنزيل PDF"
                      : "Download PDF"}
                  </button>
                </>
              )}

              {canShareCalendar && (
                <button
                  style={styles.actionButton("default", "medium")}
                  onClick={onShare}
                >
                  <Share2 size={18} />
                  {t.share}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
